import { addRouteMiddleware, defineNuxtPlugin } from '#app';
import checkEmployeeActivationMiddleware from "../middleware/employeeActivation";

export default defineNuxtPlugin(async () => {
  addRouteMiddleware('employee', checkEmployeeActivationMiddleware, {
    global: false,
  });
});
